import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Typography } from '@guildeducationinc/recess';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav/AdminTopNav';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useReports } from '@src/hooks/useReports';
import { useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
export const Reports = () => {
    const clientId = useClientIdParam();
    const { t } = useLocale();
    const { items, loading } = useReports({
        clientId,
        isActive: true,
        showInDashboard: true,
    });
    const groups = useMemo(() => {
        const _groups = {};
        if (items) {
            items.forEach(x => {
                if (!_groups[x.type]) {
                    _groups[x.type] = [];
                }
                _groups[x.type].push(x);
            });
        }
        return _groups;
    }, [items]);
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Reports') }), _jsx("div", { children: _jsx(Card, { children: _jsxs(CardContent, { children: [loading && _jsx("div", { children: t('Loading Reports...') }), !loading &&
                                Object.entries(groups).map(([key, value]) => (_jsxs("div", { className: 'margin--bottom_16', children: [_jsx(Typography, { variant: 'title3', children: t(`reportType.${key}`) }), _jsx("ul", { children: value.map(x => (_jsx("li", { children: _jsx(Link, { to: `/admin/clients/${clientId}/reports/${x.id}`, children: x.name }) }, x.id))) })] }, key)))] }) }) })] }));
};
